import React, { useEffect, useContext, useState } from "react";
import ReactLoading from "react-loading";
import "./ManageSubscription.css";
import config from "../../config";
import { AuthContext } from "../../context/AuthContext";
import MediumButton from "../../components/buttons/MediumButton";
import Subscription from "./Subscription";
import Popup from "../../components/popup/Popup";

function ManageSubscription() {
  const { user } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const reverseCTA =
    "All premium features will end. You will no longer be able to see who viewed your links & the verification badge will be removed once the billing period ends.";

  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  };

  function formatDateToUserTimeZone(dateString) {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    return new Intl.DateTimeFormat(navigator.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  }

  const cancelSubscription = async () => {
    const response = await fetch(`${config.apiUrl}/subscriptions/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user._id,
        stripeCustomerId: user.stripeCustomerId,
        stripeSubscriptionId: subscriptionInfo.stripeSubsriptionId,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to cancel subscription");
    }

    const { isCanceled } = await response.json();
    if (isCanceled) {
      setSubscriptionStatus("canceled");
    }
  };

  useEffect(() => {
    const fetchBillingDetails = async () => {
      const response = await fetch(
        `${config.apiUrl}/subscriptions/get-subscription-info/${user._id}`
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "failed to fetch subsciption info");
      }

      const { subscriptionInfo } = await response.json();
      if (subscriptionInfo) {
        console.log("subscriptioninfo", subscriptionInfo);
        setSubscriptionInfo(subscriptionInfo);
        setSubscriptionStatus(subscriptionInfo.status);
      }
      setIsLoading(false);
    };
    fetchBillingDetails();
  }, [user]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10rem",
          marginBottom: "20px",
        }}
      >
        <ReactLoading
          type={"balls"}
          color={"white"}
          height={"20%"}
          width={"20%"}
        />
      </div>
    );
  }
  return (
    <>
      <Popup
        isPopupOpen={showPopup}
        message={popupMessage}
        button2Text="Cancel Subscription"
        button2Action={() => {
          cancelSubscription();
          setShowPopup(false);
        }}
        button1Text="Close"
        button1Action={() => setShowPopup(false)}
      />
      {subscriptionStatus === "active" && (
        <div className="manage-subscription-container">
          <div className="headline-container">
            <h3>Manage Subscription</h3>
          </div>

          <div className="status-container">
            <p>
              Status:{" "}
              {subscriptionInfo?.status === "active" ? "Active" : "Inactive"}
            </p>
          </div>

          <div className="next-bill-container">
            <p>
              Next billing date:{" "}
              {formatDateToUserTimeZone(subscriptionInfo?.subscriptionEndDate)}
            </p>
          </div>
          <div className="cancel-container">
            <MediumButton
              text="Cancel"
              color="darkgrayreid"
              onClick={() => popupStatus(reverseCTA)}
            />
          </div>
        </div>
      )}

      {subscriptionStatus !== "active" && <Subscription />}
    </>
  );
}

export default ManageSubscription;
